import Authentication from "../auth/authentication";

var auth = new Authentication();

export default auth;
